class DayTipTileSlider
    constructor: (el) ->
        @.$el = el
        @.$actualEl = @.$el.querySelector '.day-tip-tile-slider__actual'
        @.$maxEl = @.$el.querySelector '.day-tip-tile-slider__max'
        @.$nextButton = @.$el.querySelector '.day-tip-tile-slider__next'
        @.$prevButton = @.$el.querySelector '.day-tip-tile-slider__prev'
        @.$slider = @.$el.querySelector '.slider'
        @.$slides = @.$el.querySelectorAll '.day-tip-tile-slider__slide'

        @.activeSlide = 0
        @.randomize = @.$el.classList.contains 'day-tip-tile-slider--randomize'

        if @.randomize
            @.RandomizeSlides()
        if @.$slides.length > 1
            @.$maxEl.innerHTML = @.$slides.length
            @.InitEvents()
        else if @.$slides.length > 0
            @.$el.classList.add 'day-tip-tile-slider--hide-controls'
        else
            @.$el.remove()
            return
        @.$el.classList.add 'day-tip-tile-slider--bound'
        return
    
    AppendSlide: (slideOptions) ->
        if slideOptions
            slideOptions.attrs = {
                class: ['day-tip-tile-slider__slide','slider__slide']
            }
            slide = window.CreateDayTipTile slideOptions
            @.$slider.querySelector '.day-tip-tile-slider__track'
                .appendChild slide
            @.$slides = @.$el.querySelectorAll '.day-tip-tile-slider__slide'
            @.$maxEl.innerHTML = @.$slides.length
            @.$slider.dispatchEvent new CustomEvent 'slider-update', { bubbles: false }
        return

    InitEvents: ->
        self = @
        @.$nextButton.addEventListener 'click', (e) ->
            self.$slider.dispatchEvent new CustomEvent 'slider-slide-to', {
                bubbles: false,
                detail: {
                    slide: self.activeSlide + 1
                }
            }
            return
        @.$prevButton.addEventListener 'click', (e) ->
            self.$slider.dispatchEvent new CustomEvent 'slider-slide-to', {
                bubbles: false,
                detail: {
                    slide: self.activeSlide - 1
                }
            }
            return
        @.$slider.addEventListener 'slider-slid', (e) ->
            activeSlide = e.detail?.activeSlide ? 0
            self.activeSlide = activeSlide
            self.$actualEl.innerHTML = self.activeSlide + 1
            return
        @.$el.addEventListener 'day-tip-tile-slider-add-slide', (e) ->
            slideOptions = e.detail?.slideOptions ? false
            if slideOptions
                self.AppendSlide slideOptions
            return
        return
    
    RandomizeSlides: ->
        self = @
        orders = []
        @.$slides.forEach (slideEl) ->
            order = Math.floor(Math.random() * self.$slides.length) + 1
            while orders.includes order
                order = Math.floor(Math.random() * self.$slides.length) + 1
            slideEl.style.order = order
            orders.push order            
            return
        return

BindDayTipTileSliders = ->
    document.querySelectorAll '.day-tip-tile-slider:not(.day-tip-tile-slider--bound)'
        .forEach (el) ->
            new DayTipTileSlider el
            return
    return

window.addEventListener 'bind-components', BindDayTipTileSliders

class DayTipTileSliderCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.hideBookmarkButtons = options?.hideBookmarkButtons ? false
        @.sliderOfText = options?.sliderOfText ? 'von'
        @.slides = options?.slides ? []
        @.startPrefixText = options?.startPrefixText ? false
        @.tabIndex = options?.tabIndex ? 2
        @.tag = options?.tag ? 'div'

        @.CreateElement()
        if !@.bindLater
            new DayTipTileSlider @.$el
        return @.$el
    
    CreateElement: ->
        self = @
        @.$el = document.createElement @.tag
        @.$el.classList.add 'day-tip-tile-slider'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.innerHTML = "
            <div class='day-tip-tile-slider__slides slider' tabIndex='#{ @.tabIndex }'>
                <div class='day-tip-tile-slider__track slider__track'></div>
            </div>
            <div class='day-tip-tile-slider__controls'>
                <button class='arrow-button arrow-button--left day-tip-tile-slider__prev'>
                    <div class='arrow-button__icon icon-arrow'></div>
                </button>
                <div class='day-tip-tile-slider__indicators'>
                  #{ if @.startPrefixText then "<div class='day-tip-tile-slider__start-prefix'>#{ @.startPrefixText }</div>" else "" }
                  <div class='day-tip-tile-slider__actual'>#{ if @.slides.length > 0 then 1 else 0 }</div>
                  <div class='day-tip-tile-slider__of'>#{ @.sliderOfText }</div>
                  <div class='day-tip-tile-slider__max'>#{ @.slides.length }</div>
                </div>
                <button class='arrow-button arrow-button--right day-tip-tile-slider__next'>
                    <div class='arrow-button__icon icon-arrow'></div>
                </button>
            </div>
        "
        trackEl = @.$el.querySelector '.day-tip-tile-slider__track'
        @.slides.forEach (slideOption) ->
            slideOption.attrs = {
                class: ['day-tip-tile-slider__slide','slider__slide']
            }
            slideOption.hideBookmarkButton = self.hideBookmarkButtons
            trackEl.appendChild window.CreateDayTipTile slideOption
            return
        return

window.CreateDayTipTileSlider = (options) ->
    return new DayTipTileSliderCreate options